import { makeStyles } from "@mui/styles"

const useStyle = makeStyles(() => ({
  row: {
    width: "100%",
    position: "sticky",
    top: 0,
    zIndex: 2,
    background: "#f9f9f9",
    boxShadow: "inset 0 -2px 0 #00a78f",
  },
  headStatus: {
    borderTop: "none !important",
    borderBottom: "none !important",
    height: 44,
    fontFamily: "Roboto",
    fontWeight: "bold",
    color: "#4B4952",
    width: "30%",
    textAlign: "center",
    position: "sticky",
    top: 0,
    zIndex: 2,
  },
  headName: {
    borderTop: "none !important",
    borderBottom: "none !important",
    height: 44,
    fontFamily: "Roboto",
    fontWeight: "bold",
    color: "#4B4952",
    width: "30%",
    textAlign: "center",
    position: "sticky",
    top: 0,
    zIndex: 2,
  },
  headDate: {
    borderTop: "none !important",
    borderBottom: "none !important",
    height: 44,
    fontFamily: "Roboto",
    fontWeight: "bold",
    color: "#4B4952",
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    cursor: "pointer",
    position: "sticky",
    top: 0,
    zIndex: 2,
  },
  headKebab: {
    borderTop: "none !important",
    borderBottom: "none !important",
    height: 44,
    fontFamily: "Roboto",
    fontWeight: "bold",
    color: "#4B4952",
    width: "5%",
    textAlign: "start",
    position: "sticky",
    top: 0,
    zIndex: 2,
  },
}))

export default useStyle
